import { render } from "./ListsImportReports.vue?vue&type=template&id=07901b5e&scoped=true"
import script from "./ListsImportReports.vue?vue&type=script&lang=ts"
export * from "./ListsImportReports.vue?vue&type=script&lang=ts"

import "./ListsImportReports.vue?vue&type=style&index=0&id=07901b5e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-07901b5e"

export default script